module.exports = __webpack_public_path__ + "img/ersonal_resources_menu_close.ec255abc.svg";